<template>
  <el-dialog
    title="查看公告"
    :visible.sync="isShowVisible"
    width="30vw"
    center
    class="noticePopupStyle"
    :close-on-click-modal="false"
    :before-close="() => $emit('close')">
    <el-form label-width="80px">
      <el-form-item label="公告内容" v-if="listData. notice">
        <span class="text">{{ listData. notice }}</span>
      </el-form-item>
      <el-form-item label="附件" v-if="listData.attachments !== undefined && listData.attachments.length > 0">
        <el-link
          class="taskAffix"
          :underline="false"
          v-for="(item, index) in listData.attachments"
          :key="index"
          :href="item.attachUrl"
        >
          <img src="../../assets/img/public/icon_pdf.png" class="taskAffixIcon" v-if="item.fileType === 'pdf'">
          <img src="../../assets/img/public/icon_excel.png" class="taskAffixIcon" v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'">
          <img src="../../assets/img/public/icon_ppt.png" class="taskAffixIcon" v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'">
          <img src="../../assets/img/public/icon_txt.png" class="taskAffixIcon" v-else-if="item.fileType === 'txt'">
          <img src="../../assets/img/public/icon_word.png" class="taskAffixIcon" v-else-if="item.fileType ==='doc' || item.fileType === 'docx'">
          <img src="../../assets/img/public/icon_img.png" class="taskAffixIcon" v-else-if="item.fileType === 'jpg' || item.fileType === 'png'" >
          <img src="../../assets/img/public/icon_default.png" class="taskAffixIcon" v-else>
          {{ item.attachName }}
        </el-link>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { getNotice } from '@api/project'
export default {
  name: 'announcement',
  props: ['projectId'],
  data () {
    return {
      isShowVisible: true,
      listData: {}
    }
  },
  mounted () {
    this.getNotice()
  },
  methods: {
    getNotice () {
      getNotice({
        projectId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.listData = res.data.data
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.noticePopupStyle{
  .text{
    font-size: 20px;
    color: #333;
  }
}
</style>
